module.exports = __webpack_public_path__ + "img/03_Gold_Award.1e0e7090.png";